module.exports = __webpack_public_path__ + "static/logo-new-b37c5b67b678be950fb6bf140e458274.webp";